function waitForElement(selector, callback) {
  if ($(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForElement(selector, callback);
    }, 500); // checks every 500 milliseconds
  }
}

waitForElement(".bcontact-embed", function () {
  var css =
    ".bcontact_textarea::placeholder { color: black !important;} .bcontact_input::placeholder { color: black !important; } .bcontact-submit-btn { width: 100%; background-color: #C8895D !important; border-radius: 50px !important;}";
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);

  // Adding a delay before applying the CSS, to ensure that the form is fully loaded.
  setTimeout(function () {
    $(".bcontact_input").addClass("bcontact_input"); // Re-trigger the style
  }, 100);
});

// waitForElement(".contact", function () {
//   var css =
//     ".bcontact_textarea::placeholder { color: black !important;} .bcontact_input::placeholder { color: black !important; } .bcontact-submit-btn { width: 100%; background-color: #C8895D !important; border-radius: 50px !important;}";
//   var head = document.head || document.getElementsByTagName("head")[0];
//   var style = document.createElement("style");
//   style.type = "text/css";

//   if (style.styleSheet) {
//     style.styleSheet.cssText = css;
//   } else {
//     style.appendChild(document.createTextNode(css));
//   }

//   head.appendChild(style);

//   // Adding a delay before applying the CSS, to ensure that the form is fully loaded.
//   setTimeout(function () {
//     $(".bcontact_input").addClass("bcontact_input"); // Re-trigger the style
//   }, 100);
// });
